import React from "react";
import Header from "./Header";
import { useCNPCImage } from "../hooks/useCNPCImage";
import { StyledShelves } from "../components/styledComponents";
import { useCNPCPrayOrderShelves } from "../hooks/useCNPCPrayOrderShelves";

function StyledPrayOrderShelvesComponent({
  setNowUrl,
  nowUrl,
  setBtnLeft,
  setBtnRight,
  btnLeft,
  btnRight,
}) {
  const imgSrc = useCNPCImage();
  const { displayCNPCPages } = useCNPCPrayOrderShelves(imgSrc);

  return (
    <>
      <Header
        setBtnLeft={setBtnLeft}
        setBtnRight={setBtnRight}
        btnLeft={btnLeft}
        btnRight={btnRight}
        nowUrl={nowUrl}
        setNowUrl={setNowUrl}
      />
      <StyledShelves>{displayCNPCPages}</StyledShelves>
    </>
  );
}

export default StyledPrayOrderShelvesComponent;
